import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Text, Loader, ContainerControlSite, ContentSmall } from '@simplybenefits/sb-ui-library';
import List from '@mui/material/List';

import Notification from './Notification.js';
import Header from '../../components/Header.js';
import { getNotifications, removeNotification } from '../../actions/notifications.js';

class Notifications extends PureComponent {
    state = {
        loading: true
    };

    async componentDidMount() {
        await this.props.dispatch(getNotifications('INTERNAL'));

        this.setState({
            loading: false
        });
    }

    _removeNotification = (notification) => {
        this.props.dispatch(removeNotification(notification.id, 'internal'));
    };

    render() {
        if (!this.props.notifications || this.state.loader?.isLoading) {
            return <Loader isContainer/>;
        }

        return (
            <ContainerControlSite>
                <Header
                    subHeader="Notifications"
                    selectedTitle="notifications"
                />

                <ContentSmall>
                    <List>
                        {
                            this.props.notifications.map((notification) => (
                                <Notification key={notification.id} notification={ notification } onClick={ this._removeNotification } />
                            ))
                        }
                    </List>

                    {
                        this.props.notifications.length === 0 &&
                        <Text
                            align="center"
                            mediumLarge
                            display="block"
                        >
                            No results to display
                        </Text>
                    }
                </ContentSmall>
                <span id="notifications" />
            </ContainerControlSite>
        );
    }
}

Notifications.propTypes = {
    notifications: PropTypes.array
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    notifications: state.notifications.items
});

export default (connect(mapStateToProps)(Notifications));